/**
 * ReactPlugin.ts
 * @copyright Microsoft 2019
 */
import { useState, useEffect, useRef } from "react";
export default function useCustomEvent(reactPlugin, eventName, eventData, skipFirstRun) {
    if (skipFirstRun === void 0) { skipFirstRun = true; }
    var _a = useState(eventData), data = _a[0], setData = _a[1];
    var firstRun = useRef(skipFirstRun);
    useEffect(function () {
        if (firstRun.current) {
            firstRun.current = false;
            return;
        }
        reactPlugin.trackEvent({ name: eventName }, data);
    }, [reactPlugin, data, eventName]);
    return setData;
}
//# sourceMappingURL=useTrackEvent.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@microsoft/applicationinsights-react-js/dist-esm/useTrackEvent.js
// module id = 522
// module chunks = 0